const Block = ({ className }) => <div className={`rounded-lg bg-[#131f37] border border-[#1e293b] animate-pulse ${className}`} />;

export const DashboardSkeleton = () => (
  <div data-testid="dashboard-loading">
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 mb-6">
      {[0, 1, 2, 3].map((i) => <Block key={i} className="h-36" />)}
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
      <Block className="h-96 lg:col-span-8" />
      <Block className="h-96 lg:col-span-4" />
    </div>
  </div>
);
